<template>
    <div class="w100">
        <article class="wContent center">
            <div class="mw-modular-box" style="margin-bottom: 0">
                <img src="../../assets/images/ad_8.png" alt="" style="height: 300px;">
            </div>
            <el-row :gutter="20">
                <el-col :span="16">
                    <div class="grid-content bgWhite p20 mw-modular-box">
                        <el-form ref="form" :model="form" label-width="120px" class="mw-feedback-box">
                            <el-form-item label="反馈类型">
                                <el-checkbox-group v-model="form.feedbackType" style="margin-left: 15px;">
                                    <el-checkbox label="网站问题" name="feedbackType"></el-checkbox>
                                    <el-checkbox label="内容问题" name="feedbackType"></el-checkbox>
                                    <el-checkbox label="业务沟通" name="feedbackType"></el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item label="反馈内容">
                                <el-input type="textarea" v-model="form.content" placeholder="我们懂得聆听，请留下您宝贵的意见" style="margin-left: 15px; width: 400px;"></el-input>
                            </el-form-item>
                            <el-form-item label="上传图片">
                                <el-upload
                                    class="inlineBlock vTop upload-add radius textCenter"
                                    style="margin-left: 15px"
                                    action=""
                                    accept=".jpg,.jpeg,.png"
                                    :show-file-list="false"
                                    multiple
                                    :http-request="uploadConfig"
                                    :on-remove="handleDelete">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                                <div class="inlineBlock radius upload-picture-box" v-for="(item, index) in pictures_list" :key="index">
                                    <img :src="item" class="w100 radius" alt="" style="height: 100%">
                                    <div class="cover radius">
                                        <a href="javascript:;" @click="handleDelete(index)">
                                            <i class="el-icon-delete"></i>
                                        </a>
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item>
                                <el-button @click="onSubmit" class="bgRed fontWhite" style="width: 200px; margin-left: 15px;">提交</el-button>
                            </el-form-item>
                            </el-form>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="grid-content">
                        <div class="w100 mw-modular-box">
                            <img src="../../assets/images/ad_3.png" alt="" class="w100">
                        </div>
                        <div class="w100 mw-modular-box">
                            <img src="../../assets/images/ad_4.png" alt="" class="w100">
                        </div>

                    </div>
                </el-col>
            </el-row>
        </article>
    </div>
</template>

<script>
import { baseUrl } from '../../assets/js/common';
import $ from 'jquery'
export default {
    name: 'FeedBack',
    components: { },
    data () {
        return {
            form: {
                feedbackType: [],
                content: ''
            },
            pictures_list: [],
            hasPicture: false,
        }
    },
    mounted () {
        // 初始化内容

    },
    methods: {
        //页面操作
        uploadConfig (file) {
            const self = this;
            if (self.pictures_list.length < 5) {
                let form = new FormData();
                // 文件对象
                form.append("files", file['file']);
                self.$post(`${baseUrl.cyw}/feedBack/upload`, form).then(res => {
                    if(res.code == 0) {
                        self.pictures_list.push(res.data[0])
                    } else {
                        self.$message.error(res.message);
                    }
                }).catch(err => {
                    self.$message.error('上传失败，请重试!');
                })
            } else {
                self.$message({
                    message: '最多上传5张图',
                    type: 'warning'
                })
            }
        },
        handleDelete (index) {
            this.pictures_list.splice(index, 1);
        },

        onSubmit () {
            const self = this;
            const token_cyw = self.$cookies.get('token_cyw');
            if (token_cyw) {
                self.$get(`${baseUrl.business}/api/user/userByToken/${token_cyw}`, {}).then(res_1 => {
                    if (res_1.status == 200) {
                        self.$get(`${baseUrl.business}/api/user/find/${res_1.data.id}`, {}).then(res => {
                            if(res.status == 200) {
                                if (res.data == null) {
                                    self.$message.error('未获取到身份信息')
                                } else {
                                    self.saveFeedBack(res.data.username);
                                }
                            } else {
                                self.$message.error(res.message)
                            }
                        }).catch(err => {
                            self.$message.error('未获取到身份信息');
                        })
                    } else {
                        self.$confirm(res_1.msg, '提示', {
                            confirmButtonText: '确定',
                            showCancelButton: false,
                            type: 'error'
                        }).then(() => {
                            self.$router.go(0)
                        })
                    }
                }).catch(err_1 => {
                    self.$confirm('未获取到用户信息，请重新登录', '提示', {
                        confirmButtonText: '确定',
                        showCancelButton: false,
                        type: 'error'
                    }).then(() => {
                        self.$router.go(0)
                    })
                })
                
            } else {
                self.$message({message: '您未登录，请登录后反馈', type: 'warning'});
            }
        },

        saveFeedBack (username) {
            const self = this;
            if (self.form.feedbackType.length == 0) {
                self.$message({
                    message: '请选择反馈类型',
                    type: 'warning'
                });
                return;
            } else if (self.form.content == '') {
                self.$message({
                    message: '请输入反馈内容',
                    type: 'warning'
                });
                return;
            } else {
                let param = $.extend(true, {}, self.form);
                param.urlList = self.pictures_list;
                param.feedbackType = param.feedbackType.join(',');
                param.account = username;
                self.$post(`${baseUrl.cyw}/feedBack/saveFeedBack`, param).then(res => {
                    if (res.code == 0) {
                        self.$message('提交成功')
                        self.form = {
                            feedbackType: [],
                            content: ''
                        }
                        self.pictures_list = [];
                    } else {
                        self.$message.error('提交失败，请重试')
                    }
                }).catch(err => {
                    self.$message.error('提交失败，请重试')
                })
            }
        }
    },
}
</script>

<style scoped>
    .upload-add {
        margin-left: 15px;
        width: 148px;
        height: 148px;
        background: #fff;
        border: 1px dotted #ccc;
        line-height: 148px;
    }
    .upload-picture-box { position: relative; height: 148px; width: 148px; margin-left: 15px }
    .upload-picture-box:hover > .cover { display: block; }
    .upload-picture-box .cover { display: none; position: absolute; top: 0; left: 0; width: 148px; height: 148px; background: rgba(0, 0, 0, .5) }
    .upload-picture-box .cover a { position: absolute; top: 58px; left: 64px; color: #fff }
    .upload-picture-box .cover i { font-size: 20px; }
</style>